import {
  AddEditOwner,
  CamAddEditBudget,
  CamAddEditCommunity,
  CamAddEditConfig,
  CamAddEditLineItem,
  AddEditProperty,
  CamAddEditVendor,
  CamBudgetMgmt,
  CamCommunities,
  CamCommunityDetails,
  CamDocumentTypeConfig,
  CamLineItems,
  Properties,
  CamUsers,
  CamUsersList,
  CamVendorMgmt,
} from "@/pages";
import { routes } from "../utils";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const CommunityRoutes = () => {
  return {
    path: routes.communities,
    children: [
      { path: "", element: <CamCommunities /> },
      {
        path: routes.id + "/" + routes.action,
        element: <CamAddEditCommunity />,
      },
      {
        path: routes.id + "/" + routes.details,
        element: <CamCommunityDetails />,
      },
      {
        path: routes.id + "/" + routes.users,
        element: <CamUsersList />,
      },
      {
        path: routes.id + "/" + routes.properties,
        element: <Properties />,
      },
      {
        path: routes.id + "/" + routes.budgetMgmt,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
            <CamBudgetMgmt />
          </PermissionGuard>
      },
      {
        path: routes.id + "/" + routes.budgetMgmt + "/" + routes.add,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET} action={routes.add}>
            <CamAddEditBudget />
          </PermissionGuard>
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.action,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
            <CamAddEditBudget />
          </PermissionGuard>
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
          <CamLineItems />
        </PermissionGuard>
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems +
          "/" +
          routes.add,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET} action={routes.add}>
            <CamAddEditLineItem />
          </PermissionGuard>
      },
      {
        path:
          routes.id +
          "/" +
          routes.budgetMgmt +
          "/" +
          routes.budgetId +
          "/" +
          routes.lineItems +
          "/" +
          routes.lineItemId +
          "/" +
          routes.action,
        element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
            <CamAddEditLineItem />
          </PermissionGuard>
      },
      {
        path: routes.id + "/" + routes.properties + "/" + routes.add,
        element: <AddEditProperty />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.action,
        element: <AddEditProperty />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users,
        element: <CamUsers />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users +
          "/" +
          routes.add,
        element: <AddEditOwner />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.properties +
          "/" +
          routes.propertyId +
          "/" +
          routes.users +
          "/" +
          routes.userId +
          "/" +
          routes.action,
        element: <AddEditOwner />,
      },
      {
        path: routes.id + "/" + routes.documentTypeConfig,
        element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE}>
            <CamDocumentTypeConfig />
          </PermissionGuard>
      },
      {
        path: routes.id + "/" + routes.documentTypeConfig + "/" + routes.add,
        element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE} action={routes.add}>
            <CamAddEditConfig />
          </PermissionGuard>
      },
      {
        path:
          routes.id +
          "/" +
          routes.documentTypeConfig +
          "/" +
          routes.documentTypeId +
          "/" +
          routes.action,
        element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE}>
            <CamAddEditConfig />
          </PermissionGuard>
      },
      {
        path: routes.id + "/" + routes.vendorMgmt,
        element: <CamVendorMgmt />,
      },
      {
        path: routes.id + "/" + routes.vendorMgmt + "/" + routes.add,
        element: <CamAddEditVendor />,
      },
      {
        path:
          routes.id +
          "/" +
          routes.vendorMgmt +
          "/" +
          routes.vendorId +
          "/" +
          routes.action,
        element: <CamAddEditVendor />,
      },
    ],
  };
};
